import { useState, useEffect } from 'react';
import { Briefcase, FileText, Users, CheckCircle, Tag, Building2 } from 'lucide-react';
import { getAdminStats } from '../../services/api';

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    getAdminStats().then(res => setStats(res.data)).catch(() => {});
  }, []);

  if (!stats) return <div className="loading"><div className="spinner"></div></div>;

  return (
    <>
      <div className="stats-grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
        <div className="stat-card">
          <div className="stat-icon blue"><Briefcase size={24} /></div>
          <div className="stat-value">{stats.totalJobs}</div>
          <div className="stat-label">Total Jobs</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon green"><CheckCircle size={24} /></div>
          <div className="stat-value">{stats.publishedJobs}</div>
          <div className="stat-label">Published Jobs</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon amber"><FileText size={24} /></div>
          <div className="stat-value">{stats.totalApplications}</div>
          <div className="stat-label">Applications</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon purple"><Users size={24} /></div>
          <div className="stat-value">{stats.totalResumes}</div>
          <div className="stat-label">Resumes</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon blue"><Tag size={24} /></div>
          <div className="stat-value">{stats.totalCategories}</div>
          <div className="stat-label">Categories</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon green"><Building2 size={24} /></div>
          <div className="stat-value">{stats.totalEmployers}</div>
          <div className="stat-label">Employers</div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
        <div className="admin-table-wrap">
          <div className="admin-table-header"><h2>Recent Applications</h2></div>
          {stats.recentApplications.length === 0 ? (
            <div className="empty-state" style={{ padding: 32 }}><p>No applications yet</p></div>
          ) : (
            <table className="admin-table">
              <thead><tr><th>Name</th><th>Email</th><th>Date</th></tr></thead>
              <tbody>
                {stats.recentApplications.map(app => (
                  <tr key={app.id}>
                    <td style={{ fontWeight: 600 }}>{app.name}</td>
                    <td>{app.email}</td>
                    <td>{new Date(app.createdAt).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        <div className="admin-table-wrap">
          <div className="admin-table-header"><h2>Recent Resumes</h2></div>
          {stats.recentResumes.length === 0 ? (
            <div className="empty-state" style={{ padding: 32 }}><p>No resumes posted yet</p></div>
          ) : (
            <table className="admin-table">
              <thead><tr><th>Name</th><th>Designation</th><th>Date</th></tr></thead>
              <tbody>
                {stats.recentResumes.map(r => (
                  <tr key={r.id}>
                    <td style={{ fontWeight: 600 }}>{r.name}</td>
                    <td>{r.designation || '-'}</td>
                    <td>{new Date(r.createdAt).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
